// Birlikte yaşamak (golf 8) için Türkçe web metinleri. samenApp.nl.ts ile aynı biçim. Sakin ve
// yetişkin dili: asla "borç", "ev işi cezası", "puan" ya da yıldız yok.
export const appSamenTr = {
    words: {
        dinnerTitle: 'Kim yemekte?',
        dinnerTitleCohousing: 'Ortak yemek',
        costsTitle: 'Masrafları paylaş',
        costsTitleCohousing: 'Ortak masraflar',
        costsTitleCouple: 'Birlikte ödemek',
        costsTitleTwoHome: 'Çocukların masrafları',
        emptyStudent: 'Henüz kimse yok. Tost mu yapılacak?',
        emptyShared: 'Henüz kimse yazılmadı.',
        emptyCohousing: 'Henüz kayıt yok.',
        formerShared: 'Eski ev arkadaşı',
        formerCohousing: 'Eski sakin',
        formerFamily: 'Eski aile üyesi',
    },
    nav: {
        dinner: 'Kim yemekte',
        dinnerCohousing: 'Ortak yemek',
        bookings: 'Rezervasyon',
        costs: 'Masraflar',
    },
    common: {
        save: 'Kaydet',
        cancel: 'Vazgeç',
        close: 'Kapat',
        saved: 'Kaydedildi',
        you: 'sen',
        left: '(taşındı)',
        undo: 'Hay aksi',
        moreActions: 'Daha fazla',
    },
    dinner: {
        intro: 'Bu akşam kim yiyor, kim pişiriyor ve saat kaça kadar yazılabilirsin.',
        emptyTitle: 'Birlikte yemek?',
        emptyBody: 'Bir son saat ve kimin pişireceğini seç.',
        start: 'Yemek listesini başlat',
        started: 'Yemek listesi hazır.',
        tonight: 'Bu akşam',
        headCook: 'aşçı {name}',
        headNoCook: 'henüz aşçı yok',
        eaters: 'Yiyenler: {n}',
        guestsExtra: '(+{n} misafir)',
        until: '{time} saatine kadar yazıl ({left} kaldı)',
        closed: 'Kayıt kapandı. {name} ile konuş.',
        closedNoCook: 'Kayıt kapandı.',
        openForYou: 'Son saat geçti ama listeyi hâlâ değiştirebilirsin.',
        noDinner: 'Bugün ortak akşam yemeği yok',
        notDinnerDay: 'Bu gün ortak akşam yemeği yok.',
        myChoice: 'Benim seçimim',
        imIn: 'Ben de yiyorum',
        imOut: 'Yemiyorum',
        noChoice: '—',
        guests: 'Misafirler',
        guestsHint: 'Yalnızca sayı; isim yok.',
        groupIn: 'Yiyor',
        groupOut: 'Yemiyor',
        groupUnknown: 'Henüz seçmedi',
        sourceDefault: 'her zamanki',
        sourceHouse: 'evin varsayılanı',
        sourceAway: 'dışarıda',
        sourceBoard: 'pano üzerinden',
        sourceBy: '{name} ayarladı',
        sourceCook: 'pişiriyor',
        setFor: '{name} için',
        cookTitle: 'Aşçı',
        cookClaim: 'Ben pişiririm',
        cookOther: 'Başkası pişiriyor',
        cookRotation: 'Nöbet çizelgesine dön',
        cookPick: 'Kim pişiriyor?',
        cookFromRotation: 'çizelgeye göre',
        noDinnerSet: 'Bugün ortak akşam yemeği yok',
        noDinnerUndo: 'Yine de ortak akşam yemeği var',
        note: 'Aşçının notu',
        noteHint: 'Evdeki herkes görür ama panoda görünmez.',
        meal: 'Menüde: {title}',
        groceries: 'Alışverişi gir',
        listChanged: 'Yemek listesi değişti · Yeniden paylaştır',
        settings: 'Yemek listesi ayarları',
        cutoff: 'Son yazılma saati',
        cutoffHint: '10:00 ile 21:00 arası.',
        days: 'Ortak akşam yemeği olan günler',
        houseDefault: 'Henüz seçmeyenler',
        houseDefaultUnknown: 'Sor',
        houseDefaultIn: 'Yiyor',
        houseDefaultOut: 'Yemiyor',
        remind: 'Son saatten önce hatırlatma',
        remindOff: 'Kapalı',
        remindMinutes: '{n} dk',
        remindHours: '{n} sa',
        cookItem: 'Çizelgedeki yemek nöbeti',
        cookItemNone: 'Yok (kendin üstlen)',
        myDefault: 'Her zamanki seçimim',
        myDefaultHint: 'Haftanın her günü için. Bir güne özel seçimin her zaman önce gelir.',
        prefIn: 'Evet',
        prefOut: 'Hayır',
        prefAsk: 'Bana sor',
        signedIn: '{name} yemekte',
        signedOut: '{name} yemekte değil',
        cleared: 'Seçim kaldırıldı',
        closedToast: 'Kayıt kapandı.',
        widgetAll: 'Yemek listesine git',
        widgetNotYet: 'Henüz seçmedin.',
        widgetYouIn: 'Yemektesin',
        widgetYouOut: 'Yemekte değilsin',
    },
    costs: {
        visibleAll: 'Evdeki herkes harcamaları ve bakiyeleri görür. AMUMIN üzerinden para geçmez.',
        visibleTwoHome: 'Bunu yalnızca ebeveynler görür. Çocuklar hiçbir şey görmez. AMUMIN üzerinden para geçmez. Panoda yalnızca, bunu bir tablet için kendin açıkça onaylarsan bir şey görünür; istediğin zaman kaldırabilirsin.',
        tabExpenses: 'Harcamalar',
        tabBalance: 'Bakiye',
        tabSettled: 'Hesaplaşılan',
        add: 'Harcama',
        empty: 'Henüz harcama yok.',
        emptyBody: 'Bir harcama gir; kimin ne alacağını AMUMIN hesaplar.',
        rowPaid: 'ödeyen {name}',
        rowFor: '{n} kişi için',
        new: 'yeni',
        edited: 'düzenlendi',
        questionBadge: 'açık soru',
        locked: 'kapatıldı',
        loadMore: 'Daha fazla yükle',
        deletedList: 'Silinenler ({n})',
        deletedHint: '30 gün boyunca geri alınabilir.',
        newTitle: 'Yeni harcama',
        editTitle: 'Harcamayı düzenle',
        amount: 'Tutar',
        amountHint: 'Örneğin 12,50',
        amountInvalid: 'Bir tutar gir, örneğin 12,50.',
        amountTooLarge: 'Bu tutar çok yüksek.',
        ambiguous: '{a} mı, yoksa {b} mi demek istedin?',
        confirmLarge: '{amount} doğru mu?',
        confirmLargeYes: 'Evet, doğru',
        description: 'Açıklama',
        descriptionHint: 'Evdeki herkes bunu görür',
        paidBy: 'Ödeyen',
        date: 'Tarih',
        dateFuture: 'Gelecekteki bir tarih olmaz.',
        dateLocked: 'O dönem kapatıldı ({date} tarihine kadar).',
        split: 'Paylaşım',
        splitEqual: 'Eşit',
        splitWeights: 'Orana göre',
        splitExact: 'Tam tutar',
        splitDinner: '{date} tarihinde yiyenler',
        splitDinnerHint: 'Yiyenler arasında paylaştırılır; misafirler getiren kişiye sayılır.',
        remaining: 'paylaştırılacak {amount} kaldı',
        tooMuch: '{amount} fazla',
        perPerson: 'Kişi başı',
        nobody: 'En az bir kişi seç.',
        enteredBy: 'giren {name}',
        editedBy: '{name}, {date} tarihinde düzenledi',
        edit: 'Düzenle',
        delete: 'Sil',
        deleteConfirm: 'Emin misin?',
        deleteBody: '30 gün boyunca geri alabilirsin.',
        deleted: 'Silindi',
        restore: 'Geri al',
        restored: 'Geri alındı',
        question: 'Bir yanlışlık mı var?',
        questionAsked: 'Sorun harcamaya eklendi.',
        questionOpen: '{name} bunun doğru olup olmadığını soruyor',
        questionResolve: 'Doğru',
        questionAdjust: 'Düzelt',
        questionWithdraw: 'Soruyu geri çek',
        detailTitle: 'Harcama',
        lockedNote: 'Bu harcama kapatılmış bir döneme ait.',
        gets: '{amount} alacak',
        owes: '{amount} hesaplaşacak',
        even: 'sıfırda',
        twoHomeOpen: 'hesaplaşılacak: {amount}',
        suggestions: 'Hesaplaşma önerisi',
        suggestionLine: '{from} → {to} {amount}',
        copy: 'Metni kopyala',
        copied: 'Kopyalandı',
        iPaid: 'Ödedim',
        wasPaid: 'Ödendi',
        settleTitle: 'Hesaplaşma',
        settleHint: 'AMUMIN üzerinden para geçmez; bu yalnızca bir not.',
        settleSaved: 'Not edildi. {name} henüz onaylayacak.',
        settleSavedConfirmed: 'Not edildi.',
        pending: 'Bekleyen hesaplaşmalar',
        pendingLine: '{from}, {amount} ödediğini bildiriyor',
        confirm: 'Doğru',
        reject: 'Doğru değil',
        waiting: '{name} bekleniyor',
        confirmed: 'onaylandı',
        unconfirmed: 'onaylanmadı',
        noLogins: 'Henüz kendi girişi olmayanlar: {names}. Davetlerini kabul edene kadar harcamalarını sen yönetirsin ve onlara yapılan bir ödeme hemen sayılır (onaylanmadı).',
        noLoginsOne: 'Henüz kendi girişi olmayan: {names}. Daveti kabul edene kadar harcamaları sen yönetirsin ve yapılan bir ödeme hemen sayılır (onaylanmadı).',
        inviteHousemates: 'Ev arkadaşlarını davet et',
        removeSettlement: 'Kaldır',
        carried: 'Devreden bakiye',
        closeTitle: 'Dönemi kapat',
        closeBody: '{date} tarihine kadar kapat.',
        closeHelp: 'Açık bakiyeler devreder. Eski kayıtlar kilitlenir ve tarihlerinden 24 ay sonra silinir.',
        closeButton: '{date} tarihine kadar kapat',
        closeQuestions: 'Önce açık soruları yanıtla ({n}).',
        closePending: 'Önce bekleyen hesaplaşmalar ({n}).',
        closeNothing: 'Henüz kapatılacak bir şey yok.',
        closed: '{date} tarihine kadar kapatıldı',
        lastClosed: 'Son kapatma: {date} tarihine kadar',
        allSettled: 'Her şey hesaplaşıldı',
        exportCsv: 'CSV olarak dışa aktar',
        settledEmpty: 'Henüz hesaplaşma yok.',
        leaverWarn: '{name} için hâlâ {amount} açık.',
        leaverHint: 'Önce bunu hesaplaşın ya da birlikte anlaşın. Bakiye genel bakışta kalır.',
        offWarn: 'Masrafları paylaş kapatılacak. Veriler 12 ay saklanır ve sonra silinir.',
        widgetGets: '{amount} alacaksın',
        widgetOwes: '{amount} hesaplaşman gerekiyor',
        widgetEven: 'Her şey hesaplaşıldı',
        widgetAll: 'Masraflara git',
        twoHomeConfirm: 'İkiniz de bu hanede ebeveyn olarak kayıtlıysanız çalışır. Çocuklar hiçbir şey görmez.',
        twoHomeConfirmYes: 'Aç',
    },
    bookings: {
        intro: 'Çamaşır makinesi, kurutma makinesi, oda ya da misafir yatağı: kimin ne zaman kullandığını gör.',
        empty: 'Henüz rezerve edilecek bir şey yok.',
        emptyBody: 'Neyi paylaştığınızı seç. Varsayılan kuralları sonra değiştirebilirsin.',
        addKind: '+ {name}',
        day: 'Gün',
        prevDay: 'Önceki gün',
        nextDay: 'Sonraki gün',
        today: 'Bugün',
        free: 'boş',
        mine: 'sen',
        closedHours: 'kapalı',
        dstHour: 'saat değişimi',
        tapFree: 'Rezervasyon için boş bir saate dokun.',
        sheetTitle: '{resource} rezerve et',
        start: 'Başlangıç',
        duration: 'Ne kadar',
        forWho: 'Kimin için',
        book: 'Rezerve et',
        booked: '{resource} {time} rezerve edildi',
        fromDate: 'Başlangıç tarihi',
        toDate: 'Bitiş tarihi (dahil)',
        maxNights: 'Arka arkaya en fazla {n} gece.',
        overlap: 'Saat {time} zaten {name} sırasında. Sıradaki boş saat: {next}.',
        overlapNoNext: 'O saat zaten rezerve edilmiş.',
        takeNext: '{time} al',
        err: {
            past: 'O saat geçti.',
            max_days_ahead: 'En fazla {n} gün önceden rezervasyon yapılabilir.',
            slot: '{n} dakikalık düzene uyan bir saat seç.',
            dst_hour: 'O saat, saat değişimi saatine denk geliyor. Başka bir saat seç.',
            max_minutes: 'Arka arkaya en fazla {duration}.',
            closed_hours: '{resource} {from} ile {until} arasında kullanılabilir.',
            quota: 'Bu hafta {resource} için zaten {n} rezervasyonun var.',
            max_days: 'Arka arkaya en fazla {n} gün.',
        },
        myTitle: 'Rezervasyonlarım',
        myEmpty: 'Hiçbir şey rezerve etmedin.',
        cancel: 'İptal et',
        cancelled: 'İptal edildi',
        done: 'Bitti, boşalt',
        freed: 'Yeniden boş',
        viaBoard: 'pano üzerinden',
        cancelledBoard: 'pano üzerinden iptal edildi, {time}',
        manage: 'Yönet',
        manageTitle: 'Rezerve edilebilecek şeyler',
        addThing: 'Bir şey ekle',
        editThing: '{name} düzenle',
        name: 'Ad',
        kind: 'Tür',
        unit: 'Rezervasyon birimi',
        unitSlot: 'zaman dilimi',
        unitDay: 'tam gün',
        slotMinutes: 'Zaman dilimi',
        defaultMinutes: 'Varsayılan süre',
        maxMinutes: 'Arka arkaya en fazla',
        maxDays: 'Arka arkaya en fazla gün',
        maxAhead: 'Önceden rezervasyon (gün)',
        perWeek: 'Kişi başı haftada',
        perWeekNone: 'Sınır yok',
        openFrom: 'Açılış',
        openUntil: 'Kapanış',
        alwaysOpen: 'Her zaman açık',
        onBoard: 'Koridordaki panoda',
        archive: 'Arşivle',
        unarchive: 'Geri al',
        archived: 'Arşivlendi',
        minutes: '{n} dk',
        hours: '{n} sa',
        widgetNext: 'Sen: {resource} {time}',
        widgetFreeNow: '{resource}: şimdi boş',
        widgetBusyUntil: '{resource}: {time} saatine kadar dolu',
        widgetAll: 'Rezervasyona git',
        kinds: {
            washer: 'Çamaşır makinesi',
            dryer: 'Kurutma makinesi',
            room: 'Oda',
            guest_bed: 'Misafir yatağı',
            other: 'Diğer',
        },
    },
    setup: {
        residents: 'Kaç kişisiniz?',
        residentsLess: 'Daha az',
        residentsMore: 'Daha fazla',
        shares: 'Neleri paylaşıyorsunuz?',
        shareNames: {
            kitchen: 'Mutfak',
            bathroom: 'Banyo',
            laundry: 'Çamaşır makinesi',
            dryer: 'Kurutma makinesi',
            common_room: 'Ortak alan',
            guest_bed: 'Misafir yatağı',
            groceries: 'Alışveriş',
            costs: 'Masraflar',
        },
        sameRights: 'Ev arkadaşları seninle aynı haklara sahip olur.',
        housemates: 'Ev arkadaşları',
        housematesHint: 'Adlarını yaz; hemen nöbet çizelgesinde ve yemek listesinde olurlar.',
        housemateName: '{n}. ev arkadaşının adı',
        housematesAdd: 'Ev arkadaşlarını ekle',
        housematesAdded: 'Eklenen ev arkadaşı: {n}',
        housemateEmail: 'Ev arkadaşı {n} e-postası (isteğe bağlı)',
        invitesSent: 'Gönderilen davetler: {n}',
        invitesLater: 'Henüz davet edilmedi. Bunu daha sonra Ev arkadaşları bölümünden yapabilirsin.',
        oneByOne: 'Ya da tek bir kişi (örneğin bir çocuk ya da bakıcı)',
        planTitle: 'Evi şöyle düzenliyoruz',
        planBody: 'Bunlar eklenir. Hiçbir şey silinmez; var olan olduğu gibi kalır.',
        planRooms: 'Odalar: {list}',
        planDuties: 'Çizelge: {list}',
        planResources: 'Rezervasyon: {list}',
        planDinner: 'Yemek listesi: {time} saatine kadar yazıl',
        run: 'Evi düzenle',
        again: 'Yeniden düzenle',
        againHint: 'Yalnızca eksik olanı ekler. Hiçbir şey silinmez.',
        doneToast: 'Ev düzenlendi.',
        nothingNew: 'Her şey zaten vardı.',
        offTitle: 'Verisi olan bir modül kapatılıyor',
        offDinner: 'Kim yemekte kapatılacak. Veriler 12 ay saklanır ve sonra silinir.',
        offBookings: 'Rezervasyon kapatılacak. Veriler 12 ay saklanır ve sonra silinir.',
        csv: 'Masrafları CSV olarak indir',
    },
    push: {
        dinner: 'Kim yemekte',
        dinnerHint: 'Son saatten önce "Yemekte misin?" sorusu; aşçı da kimin geleceğini öğrenir.',
        bookings: 'Rezervasyon',
        bookingsHint: 'Rezervasyonun birazdan başlıyor ya da biri panodan iptal etti.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: 'Davet et: {name}',
        body: 'Bağlantı içeren bir e-posta gider ve kişi kendi şifresini seçer ({name}). Ev arkadaşları seninle aynı haklara sahip olur.',
        email: 'E-posta adresi',
        send: 'Daveti gönder',
        sent: 'Davet gönderildi: {email}',
        pending: 'Davet edildi: {email}',
        resend: 'Yeniden gönder',
        taken: 'Bu kişinin zaten kendi girişi var.',
        already: 'Bu adres zaten bu eve ait.',
        limit: 'Bugün zaten 20 davet gönderildi. Lütfen yarın tekrar dene.',
        inUse: 'Bu adresin takip etmek için zaten bir daveti var. Önce onu geri çek.',
        loginNew: 'Yeni şifrenle giriş yap. E-posta adresin zaten dolduruldu.',
        hint: 'Henüz kendi girişi olmayanlar: {names}. E-postayla davet etmek için bir ada dokun.',
        landingTitle: 'Evine davet',
        landingBody: '{inviter} seni {household} evine davet ediyor. Evde {member} olarak yer alıyorsun.',
        accepted: '{household} evine hoş geldin. Artık uygulamayı kullanabilirsin.',
    },
};
//# sourceMappingURL=samenApp.tr.js.map